// @ts-nocheck
import React from 'react';
import EventFinanceReports from '@/components/admin-dashboard/EventFinanceReports';

const EventFinancePage: React.FC = () => {
  return <EventFinanceReports />;
};

export default EventFinancePage;